import { useForm, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import BeneficiaryInfoCard from "./BeneficiaryInfoCard";

export default function FACStepFour({ formStep, setFormStep, setFACFormData }) {
  const { t } = useTranslation();
  const {
    register: FACStepFourRegister,
    handleSubmit: FACStepFourHandleSubmit,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      beneficiaries: [{}],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "beneficiaries",
  });

  const onSubmit = (data) => {
    setFormStep(5);
    setFACFormData((currentFormData) => {
      return {
        ...currentFormData,
        ...data,
      };
    });
  };

  return (
    <>
      {formStep === 4 && (
        <div>
          <p className="text-sm">{t("AgentFACStepFour-heading")}</p>

          <form onSubmit={FACStepFourHandleSubmit(onSubmit)}>
            <hr />
            {fields.map((beneficiaryField, index) => {
              return (
                <BeneficiaryInfoCard
                  key={beneficiaryField.id}
                  componentIndex={index}
                  lastComponent={fields.length - 1 === index}
                  FACStepFourRegister={FACStepFourRegister}
                  append={append}
                  remove={remove}
                  errors={errors}
                />
              );
            })}

            <div className="flex justify-end">
              <button
                className="ui-btn-secondary ui-btn-min-w mt-4"
                type="button"
                onClick={() => setFormStep((current) => current - 1)}
              >
                {t("AgentFACStepFour-previousButtonLabel")}
              </button>

              <button className="ui-btn-primary ui-btn-min-w mt-4">
                {t("AgentFACStepFour-continueButtonLabel")}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
